import { render, staticRenderFns } from "./wenFang.vue?vue&type=template&id=3ddc445c&scoped=true"
import script from "./wenFang.vue?vue&type=script&lang=ts"
export * from "./wenFang.vue?vue&type=script&lang=ts"
import style0 from "./wenFang.vue?vue&type=style&index=0&id=3ddc445c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddc445c",
  null
  
)

export default component.exports